import React, { useState, useEffect } from 'react';
import { Accordion } from '@/components/molecules';
import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { IProductExtraInfoCmp } from './IProductExtraInfoCmp';

const ContentWrapper = styled.div`
  & .MuiAccordionSummary-root {
    min-height: 40px;
  }
`;
const AccordionWrapper = styled.div`
  & .MuiAccordionDetails-root {
    line-height: 24px;
  }
`;
interface IExtraInfo {
  description: string | undefined;
  heading: string;
}

const ProductExtraInfo: React.FC<IProductExtraInfoCmp> = ({ extraInfo }) => {
  const { t } = useTranslation('product');
  let content = null;

  const router = useRouter();

  const [infoState, setInfoState] = useState<string[]>([]);

  const clickHandler = (info: string) => {
    var isthere = infoState.includes(info);
    if (isthere) {
      setInfoState(infoState.filter(item => item !== info));
    } else {
      setInfoState(infoState => [...infoState, info]);
    }
  };

  const setInfoStateHandler = () => {
    setInfoState([]);
  };

  let infos: IExtraInfo[] = [];
  if (extraInfo) {
    type extraInfoKey = keyof typeof extraInfo;
    Object.keys(extraInfo).forEach(i => {
      infos.push({
        heading: i,
        description: extraInfo[i as extraInfoKey],
      });
    });
  }

  useEffect(() => {
    router.events.on('routeChangeStart', setInfoStateHandler);
    return () => {
      router.events.off('routeChangeStart', setInfoStateHandler);
    };
  }, []);

  if (infos && infos.length > 0) {
    content = infos.map(info => {
      return (
        info.description && (
          <AccordionWrapper>
            <Accordion
              withNoBorder={true}
              headingUppercase={false}
              key={info.heading}
              heading={t(`product:${info.heading}`)}
              nopaddingdetails
              expanded={infoState.includes(info.heading)}
              onClick={() => clickHandler(info.heading)}>
              <div
                dangerouslySetInnerHTML={{
                  __html: info.description,
                }}
              />
            </Accordion>
          </AccordionWrapper>
        )
      );
    });
  }

  return <ContentWrapper>{content}</ContentWrapper>;
};

export default ProductExtraInfo;
